import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Box } from '../Box';

const StyledButtonsContainer = styled(Box)<{
  direction: 'horizontal' | 'vertical';
  align: 'start' | 'end' | 'center';
  fullWidth?: boolean;
}>(({ direction, align, fullWidth }) => ({
  display: 'flex',
  flexDirection: direction === 'horizontal' ? 'row' : 'column',
  justifyContent: align === 'center' ? 'center' : `flex-${align}`,
  alignItems: direction === 'horizontal' ? 'center' : 'stretch',
  gap: 10,
  width: fullWidth ? '100%' : undefined,
}));

export type ButtonsContainerProps = {
  children: ReactNode;
  align?: 'start' | 'end' | 'center';
  direction?: 'horizontal' | 'vertical';
  fullWidth?: boolean;
};

export const ButtonsContainer = ({
  children,
  direction = 'horizontal',
  align = 'end',
  fullWidth,
}: ButtonsContainerProps) => {
  return (
    <StyledButtonsContainer
      direction={direction}
      align={align}
      fullWidth={fullWidth}
    >
      {children}
    </StyledButtonsContainer>
  );
};
